import React from 'react';
import * as Sentry from '@sentry/react';

import PublicLayout from '../layouts/PublicLayout';

// The signer's own crash screen (Nic 2026-10-24). The app-wide fallback pops
// an "Error triggered" alert and its Try Again clears storage and signs the
// person out, which also threw away a signer's saved progress (./signDraft).
// Here a crash just offers a reload: their answers come back from this
// device, and they stay signed in. Used twice: inside the page's layout (a
// crash in a field, the card or the pad) and around the whole page (a crash in
// the page itself), where withLayout puts the message in the usual frame.
class SignerErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    try {
      Sentry.captureException(error, { extra: { componentStack: info?.componentStack, where: 'signer' } });
    } catch (_) {
      /* reporting is best-effort */
    }
  }

  render() {
    if (!this.state.failed) return this.props.children;
    const message = (
      <div role="alert" className="mx-auto max-w-md px-4 py-20 text-center">
        <h1 className="text-xl font-bold text-foreground">Something went wrong on this page</h1>
        <p className="mt-2 text-muted-foreground">
          Reload to pick up where you left off. What you entered is kept on this device, except
          signatures and Social Security numbers, which you&apos;ll enter again.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="mt-4 inline-flex items-center justify-center rounded-md bg-primary px-5 py-2 text-sm font-semibold text-primary-foreground hover:opacity-90"
        >
          Reload
        </button>
      </div>
    );
    return this.props.withLayout ? <PublicLayout>{message}</PublicLayout> : message;
  }
}

export default SignerErrorBoundary;
